export default {"src":"/_next/static/media/tks.e1d7c9eb.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};